import { inject, Injectable } from "@angular/core";
import { ListingItemInterface } from "@kernel/listing/interfaces/listing-item.interface";
import { StockTypeService } from "./stock-type.service";
import { tap } from "rxjs";

/**
 * Manages stock type list interactions within the UI,
 * coordinating with services to update row state and handle user actions.
 */
@Injectable({ providedIn: "root" })
export class StockTypeListService {
  private stockTypeService = inject(StockTypeService);

  /**
   * Toggles the enabled status of a StockType row.
   * Displays a confirmation popup before calling the appropriate API
   * (enable or disable), then updates the row state based on the response.
   *
   * @param row - The table/listing row representing a StockType.
   * @returns An observable that emits when the status change completes.
   */
  switchRowStatus(row: ListingItemInterface) {
    return this.stockTypeService.switchRowStatus(row.get("id"), row.get("enabled")).pipe(
      tap(data => {
        row.set("enabled", data?.enabled);
        if (!data?.enabled) {
          row.addClass("disabled");
        } else {
          row.removeClass("disabled");
        }
      })
    );
  }
}
